import React, { useState } from "react";
import WhoWeAre from "../components/about/WhoWeAre";
import HeroSection from "../components/heroSection/HeroSection";
import ClientTestimonials from "../components/ClientTestimonials";
import AboutUs from "../components/AboutUs";
import { Helmet } from "react-helmet";
import Timeline from "../components/Timeline";
import TimelineSection from "../components/TimelineNew";
import bg1 from "../Assets/aboutbg.webp";
import about1 from "../Assets/about1.webp";


function About() {
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>About | Al Ghaith Properties</title>
        <meta name="description" content="Learn about Al Ghaith Properties, our mission, values, and commitment to delivering exceptional real estate services in Dubai." />
        <link rel="canonical" href="https://www.al-ghaith.ae/about" />
      </Helmet>
      <div data-aos="zoom-in">
        {/* <HeroSection page={"About"} /> */}
        <section
          className="relative w-full h-screen bg-cover bg-center" style={{
            backgroundImage:
               `url(${bg1})` , // replace with your image path or URL
          }}
        >
          {/* Overlay for better text readability */}
          <div className="absolute inset-0 bg-black bg-opacity-60"></div>

          {/* Content */}
          <div className="relative z-10 flex flex-col items-start justify-center h-full px-6 md:px-12 lg:px-24 text-white">
            <h1 className="text-4xl md:text-6xl font-bold mb-4 italic">
              ABOUT US
            </h1>
            <p className="text-lg md:text-2xl mb-6 italic">
              History | Vision | Mission
            </p>
            {/* Optional CTA button */}
            <a
              href="#"
              className="inline-block bg-blue-900 text-white font-semibold px-6 py-3 rounded-lg hover:bg-blue-800 transition"
            >
              Learn More
            </a>
          </div>
        </section>

        <section
          className="relative  w-full bg-gray-80 bg-cover overflow-hidden py-16 md:py-24"
          style={{
            backgroundImage:
               `url(${bg1})`, // replace with your image path or URL
          }}
        >
          {/* Paper-like diagonal corners */}
          {/* <div className="absolute top-0 left-0 w-40 h-40 bg-white rotate-45 -translate-x-20 -translate-y-20 shadow-lg"></div>
          <div className="absolute bottom-0 right-0 w-40 h-40 bg-white rotate-45 translate-x-20 translate-y-20 shadow-lg"></div> */}

          <div className="relative z-10 container mx-auto px-6 md:px-12 lg:px-20 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            {/* Text Content */}  
            <div>
              <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-2">
                OUR HISTORY
              </h2>
              <h3 className="text-xl md:text-2xl font-light text-gray-900 mb-2">
                Our Journey Through Time
              </h3>
              <p className="text-lg text-gray-600 mb-6">
                Discover the journey of resilience, heritage, and innovation.
                Our story reflects a legacy built on values and a vision for
                tomorrow.
              </p>
              <button className="bg-blue-900 hover:bg-blue-800 text-white font-semibold px-6 py-3 rounded-lg shadow-md transition">
                Learn More
              </button>
            </div>

            {/* Image with special frame */}
            <div className="relative flex justify-center">
              <div className="relative p-4 bg-white rounded-2xl shadow-2xl transform rotate-2">
                <img
                  src= {about1}
                  alt="Heritage"
                  className="w-full max-w-sm rounded-xl object-cover"
                />
                {/* Decorative frame */}
                <div className="absolute inset-0 border-4 border-blue-900 rounded-2xl -z-10 translate-x-4 translate-y-4"></div>
              </div>
            </div>
          </div>
        </section>

       



        <TimelineSection />

        <WhoWeAre />
        {/* <Timeline /> */}
        <ClientTestimonials />
        <AboutUs />
      </div>
    </div>
  );
}

export default About;
